export default __webpack_public_path__ + "static/158-47e6ef41b2fa242065f07ce8b5857af7.jpg";